import { render, staticRenderFns } from "./FolderView.vue?vue&type=template&id=a9995370&scoped=true"
import script from "./FolderView.vue?vue&type=script&lang=js"
export * from "./FolderView.vue?vue&type=script&lang=js"
import style0 from "./FolderView.vue?vue&type=style&index=0&id=a9995370&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9995370",
  null
  
)

export default component.exports